function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.307,
    height: 16,
    viewBox: "0 0 12.307 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-lock",
    d: "M17.519 8.913H16.6v-1.8a3.692 3.692 0 1 0-7.384-.05v1.85h-.928a1.543 1.543 0 0 0-1.538 1.539v7.384a1.543 1.543 0 0 0 1.538 1.538h9.231a1.543 1.543 0 0 0 1.538-1.538v-7.384a1.543 1.543 0 0 0-1.538-1.539zm-4.077 4.8v2.646a.551.551 0 0 1-.512.554.539.539 0 0 1-.565-.538v-2.662a1.231 1.231 0 1 1 1.077 0zm2.077-4.8h-5.231V7.067a2.615 2.615 0 0 1 5.231 0z",
    transform: "translate(-6.75 -3.374)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeLockIcon);
export default __webpack_public_path__ + "static/media/upgrade_lock_icon.3a14affd5cd976e20619c4ace6522757.svg";
export { ForwardRef as ReactComponent };